module.exports = __webpack_public_path__ + "img/zsdyLogo.08f6e06d.png";